import * as i0 from "@angular/core";
var ConfirmationAlertData = /** @class */ (function () {
    function ConfirmationAlertData() {
        this.resendVerificationStatus = 0;
        this.resendVerificationMessage = '';
        this.isLoading = false;
    }
    ConfirmationAlertData.prototype.init = function () {
        this.resendVerificationStatus = 0;
        this.resendVerificationMessage = '';
        this.isLoading = false;
    };
    ConfirmationAlertData.prototype.setSuccess = function (successMessage) {
        this.resendVerificationStatus = 1;
        this.resendVerificationMessage = successMessage;
    };
    ConfirmationAlertData.prototype.setError = function (errorMessage) {
        this.resendVerificationStatus = -1;
        this.resendVerificationMessage = errorMessage;
    };
    ConfirmationAlertData.prototype.setLoadingStatus = function (status) {
        this.isLoading = status;
    };
    ConfirmationAlertData.ngInjectableDef = i0.defineInjectable({ factory: function ConfirmationAlertData_Factory() { return new ConfirmationAlertData(); }, token: ConfirmationAlertData, providedIn: "root" });
    return ConfirmationAlertData;
}());
export { ConfirmationAlertData };
